module.exports = __webpack_public_path__ + "static/media/app-screens.07b75c72.png";